<template>
  <div class="sm-hint">
    <div class="sm-hint__content">
      <slot name="hintContent"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'hint-block',
}
</script>